var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-left-logo"},[_c('img',{staticClass:"logo-image pointer",attrs:{"src":_vm.logoImg},on:{"click":_vm.goToMain}})])
}
var staticRenderFns = []

export { render, staticRenderFns }